import "./EmptyState.css";

export function EmptyState({ icon: Icon, heading, description, action, secondaryAction }) {
  return <div className="empty-state">
    <span className="empty-state-icon"><Icon size="medium" aria-hidden="true" /></span>
    <h2 className="text-empty-heading">{heading}</h2>
    <p className="text-body muted-text">{description}</p>
    {action}
    {secondaryAction}
  </div>;
}
